import { useQuery } from "@apollo/client";
import { useLocation, useNavigate } from "react-router-dom";
import useCookie from "hooks/useCookie";
import { validateLoginMiraklSsoQuery } from "./queries";
import * as jose from "jose";
import { getRoutePath } from "routes/route-utils";
import { AdyenRoutesName } from "routes/route-names";
import { IAuthToken, PermissionEnum } from "TypesAndInterfaces";
import { displayError } from "utils/displayNotification";
import { useEffect } from "react";

interface ValidateMiraklSso {
  user: {
    email: string;
    permissions: PermissionEnum[];
  }
  authToken: string;
}

const LoginMiraklAuth = ({ handleShowLoginMiraklAuth }: {
  handleShowLoginMiraklAuth: (showLoginMiraklAuth: boolean) => void;
}) => {
  const [getStateCookie] = useCookie("LoginState");
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const state = params.get("state");
  const code = params.get("code");

  const handleSingleUser = (token: string) => {
    const jwt = jose.decodeJwt(token);
    const data = jwt.data as IAuthToken;
    if (data?.marketplaceId) {
      localStorage.setItem("marketplaceId", data.marketplaceId.toString());
      navigate({
        pathname: getRoutePath(AdyenRoutesName.MARKETPLACE_CONTROL),
      });
    }
  };

  const {
    data: validateHopMiraklSsoData,
    loading: validateHopMiraklSsoLoading,
  } = useQuery<{ validateLoginMiraklSso: ValidateMiraklSso }>(
    validateLoginMiraklSsoQuery,
    {
      variables: { state, code },
      skip: !state && !code,
      onCompleted: (data) => {
        if (data) {
          localStorage.setItem("authToken", data.validateLoginMiraklSso.authToken);
          localStorage.setItem("user", JSON.stringify(data.validateLoginMiraklSso.user));
          handleSingleUser(data.validateLoginMiraklSso.authToken);
          navigate(getRoutePath(AdyenRoutesName.DASHBOARD_MARKETPLACES));
        }
      },
      onError: (e) => {
        handleShowLoginMiraklAuth(false);
        displayError(e.message)
      },
    }
  );

  useEffect(() => {
    if (validateHopMiraklSsoLoading && !validateHopMiraklSsoData) {
      handleShowLoginMiraklAuth(true);
    }
  }, [validateHopMiraklSsoLoading, validateHopMiraklSsoData, handleShowLoginMiraklAuth]);

  if (validateHopMiraklSsoLoading && !validateHopMiraklSsoData) {
    return <p className="mirakl-auth-wrapper">Loading</p>;
  }

  return (
    <div className="page-mirakl">
      {validateHopMiraklSsoData?.validateLoginMiraklSso && state === getStateCookie() && (
        <div className="main-container-wrapper hop-auth-wrapper">
          <h2>Redirecting...</h2>
          <p>
            Do you have any trouble with the redirection?<br />
            Click <a href={getRoutePath(AdyenRoutesName.DASHBOARD_MARKETPLACES)}>here</a> to be redirected!
          </p>
        </div>
      )}
    </div>
  );
};

export default LoginMiraklAuth;
